var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 833.33 439.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edf1fa;}.cls-2{fill:#fff;}.cls-3,.cls-4{fill:#6772e5;}.cls-3{opacity:0.36;}.cls-5{fill:#4ce59c;}.cls-6{fill:#3ecf8e;}.cls-7{fill:#38af76;}.cls-8{fill:#fa755a;}.cls-9{fill:#ef4b2d;}.cls-10,.cls-15,.cls-16,.cls-18,.cls-24,.cls-25,.cls-26{fill:none;}.cls-10{stroke:#ececec;stroke-width:1.5px;}.cls-10,.cls-16,.cls-17,.cls-18{stroke-linecap:round;stroke-linejoin:round;}.cls-11{fill:url(#linear-gradient);}.cls-12{fill:#e02001;}.cls-13{fill:#ffd731;}.cls-14{fill:#5acc5a;}.cls-15{stroke:#edf1fa;}.cls-15,.cls-24,.cls-25,.cls-26{stroke-miterlimit:10;}.cls-16,.cls-17,.cls-24{stroke:#6772e5;}.cls-16,.cls-17{stroke-width:3px;}.cls-17{fill:#004d9c;}.cls-18,.cls-26{stroke:#f15a24;}.cls-18{stroke-width:2px;}.cls-19{fill:#4a5bd3;}.cls-20{fill:#ef4c2e;opacity:0.34;}.cls-21{fill:#ffb497;}.cls-22{fill:url(#linear-gradient-2);}.cls-23{fill:url(#linear-gradient-3);}.cls-25{stroke:#4ce59c;}.cls-27{fill:url(#linear-gradient-4);}.cls-28{fill:url(#linear-gradient-5);}.cls-29{fill:url(#linear-gradient-6);}.cls-30{fill:#f9a47c;}.cls-31{fill:url(#linear-gradient-7);}.cls-32{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1161,
    y1: 744.15,
    x2: 1544.57,
    y2: 744.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6772e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6760e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6760e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 973.27,
    y1: 673.72,
    x2: 1000.43,
    y2: 673.72,
    gradientTransform: "matrix(-0.8, 0, 0, 1, 2259.63, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e2833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 918.35,
    y1: 665.18,
    x2: 938.75,
    y2: 665.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 953.82,
    y1: 512.94,
    x2: 971.75,
    y2: 485.48,
    gradientTransform: "matrix(-0.8, 0, 0, 1, 2259.63, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020b17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1417.19,
    y1: 550.32,
    x2: 1494.83,
    y2: 550.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1459.26,
    y1: 560.95,
    x2: 1468.05,
    y2: 560.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1221.35,
    y1: 626.8,
    x2: 1264.39,
    y2: 626.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1461.79,
    y1: 528.57,
    x2: 1441.34,
    y2: 508.37,
    gradientTransform: "matrix(-0.93, 0, 0, 1.02, 2587.79, -11.54)",
    xlinkHref: "#linear-gradient-4"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ill-6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 833.33,
    height: 439.16,
    rx: 12,
    ry: 12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    "data-name": "Layer 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glass"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1033.93,677.78l65.55.47a3,3,0,0,1,3,2.91c.3,10.27,1.15,44.85-.61,54.08s-13.85,27-17.24,31.89a3,3,0,0,1-2.41,1.28l-31,.47a3,3,0,0,1-2.56-1.36c-3.61-5.53-16.77-26.1-17.22-32.8-.26-3.86-.39-18-.45-31.2,0-9.36-.06-18.26-.06-22.74A3,3,0,0,1,1033.93,677.78Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1102.77,704.7s-16.15-12.39-28.57-2c-8.41,7-15.21,6.46-19.33,4.87a13.76,13.76,0,0,1-5.29-3.81c-2.38-2.7-9.27-8.54-18.6.54l.44,30a6.41,6.41,0,0,0,.09,1c.5,2.94,3.56,17.33,18,33.63l34.29,0s16.72-21.66,18-33.65S1102.77,704.7,1102.77,704.7Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1102.63,706.53s-13.85-9-26.28,1.34c-14.14,11.79-23.37,4-23.37,4s-10.18-8.93-21.83,2.43l.26,20a6.41,6.41,0,0,0,.09,1c.5,2.94,3.56,17.33,18,33.63l34.29,0s16.72-21.66,18-33.65S1102.63,706.53,1102.63,706.53Z",
    transform: "translate(-968.1 -329.79)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1590.49,698.81s11.74-63.69-50-97.79-64.72-33.72-76.85-37.66c-7-2.42-14.19,2.6-6.12,12.78s3.52,12.81,19.73,17.26S1496,617.7,1504,622.56s15.19,6.22,40,16.88c22.45,9.65,41.71,37.11,41.69,46.82s22,12.88,22,12.88Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1588.23,689.88s15.66-58.63-38.32-90.26-72.88-31.35-83.5-35.14c-6.16-2.15,10.62,5.4,17.7,14.81s5.35,7.32,18,14.28c14.71,8.12,20.83,16,29.42,17.65,12.55,2.43,8.8,15.36,30.48,25.24,19.61,8.92,22.11,32.72,22.09,41.71s19.25,12,19.25,12Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1642.62,681.3l6.07-5.76a23.78,23.78,0,0,1,10.43-5.65c19.13-5,79.14-23.76,104-69.23a.84.84,0,0,0-.51-1.17,1.1,1.1,0,0,0-.32-.08c-8.26-.65-51-1.31-108.06,47.45a16.75,16.75,0,0,0-2.76,2.85c-1.44,2-3.84,5.36-4.86,7.18-1.52,2.61,1.47,7-2.54,10.92s-12.57,13.48-12.57,13.48l7,5.24Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1610.21,677.48s16.39-146.6-28.3-192.68c-41.2-42.36-41.8-3.37-41.65,3.17a3.41,3.41,0,0,0,.44,1.61,91.78,91.78,0,0,1,9.59,59.24c-4.21,21.2,26.06,18.42,28.65,39.33s13.19,53.09,12.11,67.92-1.15,29.23-1.15,29.23l16.52.5Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1610,678a3.29,3.29,0,0,0,.28-1c1-9.58,14.79-147.68-28.36-192.16-40.9-42.16-41.5-4-41.35,2.87a5.62,5.62,0,0,0,.93,2.31c3,4.35,16.5,23.61,28.54,21.39,33.07-5.93,3.88,33.92,21.89,55.18,14.36,16.81,9.61,74.84,8.52,89.7a152.63,152.63,0,0,1-4.19,24.77,3.82,3.82,0,0,0,3.33,4.51,4.88,4.88,0,0,0,.76.08h3a4.41,4.41,0,0,0,4.22-2.38Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1626.06,686.51s2.86-40.59,26.56-65.43a48.8,48.8,0,0,1,24.16-13.55c7.05-1.63,18.72-7.33,28.77-26.28,0,0,19.13-27,38.21-35.25s0-9.16,0-9.16-54.59,10.4-89.6,42.37a64.22,64.22,0,0,1-7,5.54C1638,591,1613,614.39,1614,682.67Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1673.52,683.23s.81-4.94-5.66-4.81c-5.68.2-102.07-.53-102.07-.53s-4.46,0-4.19,3.37,14.93,83.68,16.3,85.36a4.83,4.83,0,0,0,2.75,2.14c1.79.53,69.5.11,69.5.11a3.28,3.28,0,0,0,2.92-3.08c-.19.12,20.65-81.57,20.46-82.55",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1673.52,683.23s.81-4.79-5.66-4.81l-19.69-.05c1.1.75,3.66,23.52,2.65,39.53a51.16,51.16,0,0,1-3,14c-3.88,10.89-13.17,36.08-14.22,36.87l16.5.07a3.7,3.7,0,0,0,3-3.3c-.08.21,20.54-81.36,20.35-82.34",
    transform: "translate(-968.1 -329.79)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "book1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1506,716.66H1360.65a11.89,11.89,0,0,1-11.71-12V691.77a11.89,11.89,0,0,1,11.71-12H1506c6.44,0,10.63-1.93,10.63,4.67l.29,30C1516.9,721,1512.42,716.66,1506,716.66Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1522,763.66H1376.65a11.89,11.89,0,0,1-11.71-12V738.77a11.89,11.89,0,0,1,11.71-12H1522c6.44,0,10.63-1.93,10.63,4.67l.29,30C1532.9,768,1528.42,763.66,1522,763.66Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1167,677",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1168.33,677.41S1148,679,1148,699s21,21,21,21l354,1v-6H1365s-5,1-4-7V687a4.52,4.52,0,0,1,4.76-4.72C1372.85,682.2,1521,684,1521,684v-8Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 356.35,
    x2: 547.9,
    y2: 357.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 360.35,
    x2: 547.9,
    y2: 361.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 364.35,
    x2: 547.9,
    y2: 365.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 368.35,
    x2: 547.9,
    y2: 369.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 373.35,
    x2: 547.9,
    y2: 374.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 378.35,
    x2: 547.9,
    y2: 379.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 394.9,
    y1: 382.35,
    x2: 547.9,
    y2: 383.07
  })), /*#__PURE__*/React.createElement("g", {
    id: "book2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1184,725",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1183,720s-22,2.33-22,24.56c0,19,15.44,23.38,19.86,24.24a10.65,10.65,0,0,0,2,.19l361.69.4-.29-7L1404,762s-9-.11-8-9V734s-1-7,7-7c7,0,139.25,1.49,139.25,1.49v-9.57Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 402.31,
    x2: 563.88,
    y2: 403.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 406.31,
    x2: 563.88,
    y2: 407.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 410.31,
    x2: 563.88,
    y2: 411.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 414.31,
    x2: 563.88,
    y2: 415.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 419.31,
    x2: 563.88,
    y2: 420.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 424.31,
    x2: 563.88,
    y2: 425.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 430.92,
    y1: 428.31,
    x2: 563.88,
    y2: 429.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1387.4,686.72h12a17.8,17.8,0,0,1,7,10c2,7,0,9,4,17,2.36,4.71,5.13,7.83,7,11,.39.67.9,5.23,1,6l1,12-5-3-5,5s0-16-2-19-9.89-14-9-22C1399.4,694.72,1396.4,691.72,1387.4,686.72Z",
    transform: "translate(-968.1 -329.79)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1187,418.67s0-10.67,11.75-10.67h300.87s11.75,2.13,11.75,12.81V660c0,1.16,0,3.6,0,4.76,0,4.16,1.53,12.23-11.8,12.23H1198.75S1187,677,1187,662.06Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 237.04,
    cy: 90.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 248.53,
    cy: 90.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 260.02,
    cy: 90.02,
    r: 3.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.9,
    y: 99.21,
    width: 312,
    height: 241
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 290.38,
    y1: 99.7,
    x2: 290.94,
    y2: 339.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.82,
    y: 280.15,
    width: 217.5,
    height: 60.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 302.23,
    y: 121.79,
    width: 47.55,
    height: 32.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 360.84,
    y: 121.79,
    width: 47.46,
    height: 32.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 419.44,
    y: 122.41,
    width: 47.53,
    height: 32.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 478.36,
    y: 123.04,
    width: 47.68,
    height: 32.35
  }), /*#__PURE__*/React.createElement("image", {
    width: 192,
    height: 192,
    transform: "translate(422.1 132.46) scale(0.07)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    width: 96,
    height: 96,
    transform: "translate(481.81 134.09) scale(0.11)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    width: 192,
    height: 192,
    transform: "translate(362.65 132.05) scale(0.07)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    width: 144,
    height: 144,
    transform: "translate(304.55 131.93) scale(0.08)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    id: "det"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 235.34,
    y1: 155.6,
    x2: 282.92,
    y2: 156.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 234.34,
    y1: 187.6,
    x2: 281.92,
    y2: 188.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 234.34,
    y1: 206.6,
    x2: 281.92,
    y2: 207.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 234.34,
    y1: 224.6,
    x2: 281.92,
    y2: 225.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 234.34,
    y1: 240.6,
    x2: 281.92,
    y2: 241.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 234.44,
    y1: 171.42,
    x2: 282.01,
    y2: 171.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 239.3,
    y1: 113.49,
    x2: 274.99,
    y2: 113.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 324.26,
    y1: 137.68,
    x2: 339.77,
    y2: 137.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 383.27,
    y1: 138.4,
    x2: 398.79,
    y2: 138.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 443,
    y1: 139.47,
    x2: 458.52,
    y2: 139.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 500.95,
    y1: 139.11,
    x2: 516.46,
    y2: 139.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 494.2,
    y1: 111.27,
    x2: 529.89,
    y2: 111.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 302.18,
    y: 165.95,
    width: 93.75,
    height: 98.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 415.4,
    y: 166.92,
    width: 111.6,
    height: 98.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1319.09,530.87l.23-19.13s13.75,1.13,22.33,10.15c7.59,8,9.06,16.73,9.55,22.24l-19.28-.2S1332.13,533.09,1319.09,530.87Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1307.72,556.23s4.86,5.61,14.28,3c0,0,7.28-1.43,10.29-12.24l18.77,0s.31,11.92-7.75,20.53c-8.32,8.9-12.13,8.92-16.67,10.27s-17.36,2.37-27.49-4.39l-5.39-4.3Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1301.21,530l.29-19.09s-9.11-.45-19.19,6.79S1270,536.66,1270,536.66a32.22,32.22,0,0,0,0,14.15,42.27,42.27,0,0,0,6.71,14.73l14-12.53s-3-4.8-2.77-8.92,1-5.83,3.36-9C1292.77,533.17,1295.54,530.53,1301.21,530Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1315.88,531l.29-19.09s-9.11-.45-19.19,6.79-12.31,18.93-12.31,18.93a32.22,32.22,0,0,0,0,14.15,42.27,42.27,0,0,0,6.71,14.73l14-12.53s-3-4.8-2.77-8.92,1-5.83,3.36-9C1307.44,534.17,1310.21,531.53,1315.88,531Z",
    transform: "translate(-968.1 -329.79)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boy"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "506.34 329.16 508.28 343.41 504.08 341.87 500.7 341.51 499.06 332.06 506.34 329.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1477,672.52a.14.14,0,0,1,.13.14l.08,3.36s.17.9-.61,1-17.87.11-18.08,0-1.37-.14-1.8-.51-2.95-2.4.36-3.71,10.92-2.48,11.49-2.48S1473.05,672.58,1477,672.52Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1513,651.09l3.36,5.56-5.59,6.34a43.9,43.9,0,0,0-3-5.2C1507,656.8,1513,651.09,1513,651.09Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1516.29,656.46l4.69,3.86a1.12,1.12,0,0,1,.41,1,2.7,2.7,0,0,1-.78,1.54c-1,1.05-10,10.43-10.74,10.55,0,0-7.21,2.49-4.07-3.83.18-.37-.35.52-.06.23a19.9,19.9,0,0,0,4.71-7C1511.39,660.1,1516.29,656.46,1516.29,656.46Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "433.06 251.37 445.93 245.17 460.98 239.78 473.43 251.3 492.1 218.62 503.61 227.34 507.33 237.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "432.89 230.43 458.42 209 472.16 201.38 480.14 183.64 493.9 200.18 504.06 213.81 518.34 210.61 530.04 222.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "433.05 240.43 459.93 229.59 466.01 227.43 471.39 220.93 477.19 208.81 490.56 228.08 498.36 237.83 508.44 224.83 519.81 221.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1491.73,515.2c.61.55.18.51-.7.79-2.15.69-9.21,5.42-17.77,1.62,0,0-2.65-1.79,3.43-2.73,5.19-.8,9.91-1.81,11.18-2.09a1.49,1.49,0,0,1,.71,0A13.24,13.24,0,0,1,1491.73,515.2Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1470.81,491.1s-3.59,20,5.41,21.24c0,0,1.38.31.68,1.94-.23.54-.48.61-1.09.78l-.65.12s11.2,2.8,12.77-2.36a4.9,4.9,0,0,1-3-2.75c-.79-2.11-.07-10.54-.07-10.54l-4.43-8.12-7.57-2.26Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1473.11,494.14a2.39,2.39,0,0,1-2.18-.46c-1.83-1.5-5-4.86-2.34-8.09,1.82-2.19,2.74-2.52,3.19-2.31a1.39,1.39,0,0,0,1.44-.29,2.15,2.15,0,0,1,2.91.21c2.55,2,3.89,3.85,4.74,3.85s2.07.66,3.53-.8,5.11.66,5.23,3.72,3.65,1.59,3.65,1.59,3.53.13,2.31,3.45,3,3.85-1.7,5.31-1.08,2.41-1.08,2.41,1.45,2.78-1.71,2.51.49,2,.49,2,.85,4.25-2.43,3.06-3.4-.09-4.13,1.11-7.8.76-7.43-3.36,2.74-3.25,2.86-5.39c.14-2.5.43-4.47-.79-4.61s-2,1.64-3.22,1.64-2.66-.79-.71-4C1477.1,493.44,1474.65,493.76,1473.11,494.14Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boyc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1464,589.54s-4.06,32.67-3.69,40.61,4.43,30.46,5.72,33.23,10.89.92,10.89.92.92.37.92-1.85-3.69-27.32-2.58-30.64,4.61-29,5.9-29.78,1.3,4.49,5.36,21.66a16.79,16.79,0,0,0,2,6.46c1.85,3.32,18.73,27.73,18.73,27.73l6.54-6.42s-11.24-25.55-12-29.8-6-46-6-48.43-30.56,1.11-30.56,1.11Z",
    transform: "translate(-968.1 -329.79)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1469.41,577.66s7.23,17.79,16.15,27.14c3.64,3.82,5,17.57,8,19.44,4.71,2.88,6.09,4.75,4.67,11.4-.88,4.13,12.44,9.1,12.44,9.1l-8.86-22.09-3.16-24.4-2.67-24Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1488.83,511.57s10.64,6.11,12.28,12.68,2.67,24.86,2.24,28.5-2.07,33.11-2.07,33.11-.09,1.15-.69,1.33-11.2.27-11.2.27-.78.09-.78-1.07-1-9.06-1-9.06-1.38-1.15-1.64.27-1,9.06-1,9.06-.09,1.07-1,1.15-21.89-.44-22.41-1.33a1.08,1.08,0,0,1-.95-1.15c0-1.07,9.76-52.44,9.33-54.48s5.08,10.76,3.51,5.84c-1.8-5.63-3.79-9.13-4.39-11.79s2.55,2.17,3.24,2.08,15.59,40.23-3-10.4c-.16-.42,5.54,14,5.78,11.56.31-3.2,11,8.85,1.39-5.32-2.12-3.12-4.32-7.15,1.55-6.39C1480.24,516.73,1488.83,511.57,1488.83,511.57Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1418.42,536.19a20.14,20.14,0,0,1-3.87,0,13.6,13.6,0,0,0-8.88-.62,19,19,0,0,1-8.91.18s-1,.42,0,.89,7.64.69,8,1.38-1.06,2.5.88,3.1,7.43.33,8.47-.8,3.38.89,3.38.89Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow",
    className: "cls-28",
    d: "M1487.6,512.53l2.86,4.2a13.42,13.42,0,0,1,1.9,4.2l1.82,7.06c.1.38.17.76.24,1.15a20.18,20.18,0,0,1,.42,3.88l-1.27,54.33s-4.94.49-4.94-.66-1-9.08-1-9.08-1.38-1.16-1.64.27-1,9.08-1,9.08-.09,1.07-1,1.16-21.89-.45-22.41-1.34a1.08,1.08,0,0,1-.95-1.16c0-1.07,8.41-46.89,8-48.93s-2.31-3.93-12-.69c-5.62,1.87-10.4,2.31-17.57,3.47-2.7.44-21.73,3.93-21.73,3.24,0-3,2-9.23,2.08-8.78s8.21-2,10.63-1.85c4.39.23,28.65-6.14,31.21-7.63,5.55-3.24,12.42-11.28,17.88-10.57C1482.67,514.33,1487.6,512.53,1487.6,512.53Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1453.49,567.62l-13.17-24.07a.43.43,0,0,0-.45-.5c-.51,0-16.47,5.34-16.47,5.34s-.45,0-.45.56,14.25,25.25,14.25,25.25.11.56.62.43,15.62-6.39,15.62-6.39S1453.72,568.12,1453.49,567.62Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1462.14,564.77a15.67,15.67,0,0,1-8.57,2.42c-5-.08-7.53-1.61-7.53-1.61s-.66-.89.74-1,5-.25,3.08-3.41a26.9,26.9,0,0,0-2-3.78s-1.52-2.36-.56-1.54c.78.66,6.94,6.07,12,4.3s3.25,2.42,3.25,2.42Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1466.2,556l-6.94,4.2s2.88,4.38.74,5.75l8.05-1Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.05,
    y1: 261.18,
    x2: 428.13,
    y2: 261.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.33,
    y1: 212.76,
    x2: 428.41,
    y2: 212.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 448.09,
    y1: 261.18,
    x2: 453.17,
    y2: 261.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 460.09,
    y1: 261.18,
    x2: 465.17,
    y2: 261.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 471.09,
    y1: 261.18,
    x2: 476.17,
    y2: 261.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 481.09,
    y1: 261.18,
    x2: 486.17,
    y2: 261.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 491.09,
    y1: 261.18,
    x2: 495.69,
    y2: 261.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.31,
    y1: 179.22,
    x2: 428.39,
    y2: 179.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.3,
    y1: 187.35,
    x2: 428.38,
    y2: 187.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.29,
    y1: 195.79,
    x2: 428.37,
    y2: 195.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.3,
    y1: 203.84,
    x2: 428.38,
    y2: 203.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.3,
    y1: 220.36,
    x2: 428.38,
    y2: 220.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.32,
    y1: 228.74,
    x2: 428.4,
    y2: 228.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.3,
    y1: 235.85,
    x2: 428.38,
    y2: 235.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.32,
    y1: 252.74,
    x2: 428.4,
    y2: 252.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 423.3,
    y1: 243.85,
    x2: 428.38,
    y2: 243.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 435.24,
    y1: 261.04,
    x2: 440.32,
    y2: 261.04
  })), /*#__PURE__*/React.createElement("g", {
    id: "girl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1264.16,671.68a3,3,0,0,0,2.11,1.3,63.38,63.38,0,0,1,8.27,1.26c3.52,1,1.49,3.23.41,3.38s-13.22.08-15.9.07a1.46,1.46,0,0,1-1-.39c-.39-.35-.88-.89-.88-1.33,0-.73.54-5.45.54-5.45l5.83.36Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1234.11,672.49a6,6,0,0,1,2.51,2.15s.86.77-.14,2.18c-.81,1.14-5.65.7-7.3.68-.79,0-1.71-1.23-2-2a2.84,2.84,0,0,1,.61-3.16C1229.83,669.94,1234.11,672.49,1234.11,672.49Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1264.08,670.5l-6.44.05a8,8,0,0,0,.33,2.12c.81,2.36,4.27,2.85,6-.44C1264.22,671.78,1264.08,671.3,1264.08,670.5Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1234,670.78l-6.79-.42a14.12,14.12,0,0,0-.06,2.15c.18,2.6,5.23,3.57,7,0C1234.4,672,1234,671.62,1234,670.78Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1256.16,579.37s6.92,34.48,7.12,38.06,1.19,14.21,1.1,16-.24,37.28-.24,37.28-2.64,4.49-6.69.13c0,0-1.64-40.58-2.73-42.37s-12.54-38-15.69-39.84c0,0-1-1.49-1,2.29s-.66,35.88-1,37.57-2.82,44.13-2.82,44.13-4,3.38-7.29.4l.45-44.92s-7.22-39.75-5.95-43.23S1256.16,579.37,1256.16,579.37Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow-2",
    "data-name": "shadow",
    className: "cls-19",
    d: "M1245.52,602.31s2.47-1.12,3.73-9.82a5.77,5.77,0,0,1,1.05-2.6,16.21,16.21,0,0,1,5.25-4.64,3.92,3.92,0,0,0,1-.85h0a.63.63,0,0,0,.13-.58l-.57-6.91L1233,581.57l-12.14.33s1.22,12.58,1.31,14.17,4.46,27.68,4.64,28.67.32,1.51.32,1.51,4.88-3.17,4.88-6.16.36-8.88,1.47-12.25,2.06-9.26,3.56-14.95c0-.19.35-1.85.38-2,.11-.77,0-2.14.71-2.43s1.37,1.38,1.37,1.38Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1240.16,518.57l7.32-.23a5,5,0,0,1,5.3,3.4c1.58,4,11.39,23.54,11.39,23.54s1.7,5,9.29,1.24c4.65-2.28,11.61-8.67,11.61-8.67s1.61-1.44,2.17-1.24,1.14,1.12,1.14,1.12,4.33,3.21,4.12,3.52-22.75,16.87-22.75,16.87-4.48,4.61-13.78-7.4c0,0-5.06-7.08-2.57.72s7.25,30.39,7.25,30.39-.34.91-1.58.57-13.76-3.29-21.64,4.8-17-1-17-1-.55-.76-.18-1.32,5.1-29.88,4.24-33.46-3.55-11.89-4.35-12.69-.79-1.42-1.77-.8-1.08,3.74-1.08,3.74-1,0,.68,1.22l3.38,7.09s1.57-1,1-.85-3.71-5.64-3.28-2.87c0,0,.24,2.9-.13,2.53a9.54,9.54,0,0,1-.85-2.39s-1.59-7.54,3.1-12.79a13.71,13.71,0,0,0,3.11-11.65s-1-3,3.18-3.7S1240.16,518.57,1240.16,518.57Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow-3",
    "data-name": "shadow",
    className: "cls-6",
    d: "M1240.16,518.57l2.73.5s-.8-.17.78,3.81,2.44,2.8,4,11.43a32.23,32.23,0,0,1-1.75,17.28,6.83,6.83,0,0,0-.37,1.18c-.68,3.21-4.41,12.13-8.39,23.23-2.07,5.77-11.36,4-14.44,3.2a1.46,1.46,0,0,1-1.1-1.29c-.12-1.24.53-3.43.47-3.88-.15-1.11,3.2-19,2.34-22.61s-1.49-8.81-2.28-9.61,5.37,1.64,4.4,2.26-6.44-1-6.44-1,21.53-13.51,23.18-12.28l2.13,4.47s-15.58,9.26-16.09,9.49c-.91.42,1.95,12.16-3.86,13.36,0,0-3.81-1.3-7.47-6.58a20.54,20.54,0,0,1-1.65-4.75,5.66,5.66,0,0,1-.08-2.44,82.67,82.67,0,0,1,3.28-12.1c2.33-6.64,3.76-11.08,3.76-11.08s-.06-2.22,4.15-2.9S1240.16,518.57,1240.16,518.57Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1256.63,500.17",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1255.35,499.57s-1.4,12-13.15,13.46,1.71-12.81,1.71-12.81Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1290.93,539.78s2.45-2.88,3.51-3.33a23.47,23.47,0,0,0,3.75-3.17s.05-.87-.1-.86l-.8-.39s-.37-.37-.19-.56,2.79-2.33,2.79-2.33.11-.44-.27-.28a15.84,15.84,0,0,0-3,1.81c-.69.64-2.9,2-3.07,1.8a3.05,3.05,0,0,1,0-1.74,4,4,0,0,0,.12-1.29s-.11-.31-.24-.05-1.09,3.89-1.67,4.47c0,0-3.07,3.8-3.21,4S1290.93,539.78,1290.93,539.78Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1263.31,527.14s4.81-.73,5.62-1.43a24.09,24.09,0,0,1,4.3-2,8.63,8.63,0,0,1,1.44,0s0,0,0,0l1.58-.12s-.84,1.21-1.53,2.1-.26,1.27-.35,1.46.29.67.71.66a7.57,7.57,0,0,1,1.73.61,3.74,3.74,0,0,1-1.74.46,21.7,21.7,0,0,0-4.76-.15,28.17,28.17,0,0,1-3.81,1.55C1266.24,530.21,1263.31,527.14,1263.31,527.14Z",
    transform: "translate(-968.1 -329.79)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-32",
    d: "M1250.55,501.48s1.24,1.42,5,1.22c2.35-.12,3.2-1.94,4-3.24a3.74,3.74,0,0,0,.46-2.79,8.47,8.47,0,0,0-2-4.22c-1.82-1.64-11.09-11.69-23.45,1.27a4.76,4.76,0,0,1-1,.8c-3,1.79-17.32,11.16-11.68,23.18a2.68,2.68,0,0,1,.17.47c.27,1,1.31,5.11,1.6,7.27a6.64,6.64,0,0,0,1.5,3.39c2.47,2.92,7.37,7,10.32-2.27,0,0,1.07-4.36,4.28-.8a5,5,0,0,0,2.64,1.54c2.48.05,6.84-1.95,4-7.26a5,5,0,0,1-.61-2.21c-.08-2.65-.06-8.74,1.67-10.66a2,2,0,0,0,.09-2.62l0-.06a2.32,2.32,0,0,1-.16-2.55c.34-.59.79-1.13,1.3-1.16C1250.49,500.68,1250.55,501.48,1250.55,501.48Z",
    transform: "translate(-968.1 -329.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1256.27,529.7s4.64-1.36,6.65-3.12c.72-.63,4.1,4.31,5,3.93s-8.12,5.86-8.12,5.86Z",
    transform: "translate(-968.1 -329.79)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.998c030a4c8b5ff444eb7564cba89605.svg";
export { ForwardRef as ReactComponent };